module.exports = __webpack_public_path__ + "static/media/chatWithVane.7e3af554.svg";